module.exports = __webpack_public_path__ + "static/media/Image1.8fa1da19.png";